module.exports = __webpack_public_path__ + "d26871e8149b5759f814fd3c7a4f784b.woff2";